const contentCache = {
  files: new Map(),
  subscribers: new Map(),
  
  getContent(key) {
    return this.files.get(key);
  },
  
  setContent(key, content) {
    this.files.set(key, content);
  },
  
  hasContent(key) {
    return this.files.has(key);
  },

  getSubscribers() {
    return this.subscribers.get('list');
  },

  setSubscribers(list) {
    this.subscribers.set('list', list);
  }
};

export default contentCache;
